module.exports = __webpack_public_path__ + "img/inflable-base.6be64d2d.svg";